import { DisplayInfo, Table } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';

import { DebtPublicationRun } from '../api';
import { useDebtPublicationColumns } from '../hooks/useDebtPublicationColumns';

const dictPrefix = 'financialPortal.debtPublication.table';

interface Props {
  data: DebtPublicationRun[];
  isLoadingResults: boolean;
  totalItems: number;
  totalPages: number;
  currentPage: number;
  itemsPerPage: number;
  onChangePage: (page: number) => void;
  onDownload: (row: DebtPublicationRun) => void;
}

export function RunTable({
  data,
  isLoadingResults,
  totalItems,
  totalPages,
  currentPage,
  itemsPerPage,
  onChangePage,
  onDownload,
}: Props) {
  const { t } = useTranslation();
  const columns = useDebtPublicationColumns({ onDownload });

  return (
    <Table
      isLoadingResults={isLoadingResults}
      data={data}
      columns={columns}
      pagination={{
        currentPage: currentPage + 1,
        itemsPerPage,
        totalItems,
        totalPages,
        onChangePage: (page) => onChangePage(page - 1),
      }}
      noResultsText={
        <div className="d-flex justify-content-center align-items-center py-5">
          <DisplayInfo
            iconName="information"
            textBody={t(`${dictPrefix}.noResults.description`)}
            maxWidth="650px"
          />
        </div>
      }
    />
  );
}
